export const NEW = 'new';
export const ASSIGNED = 'assigned';
export const IN_PROGRESS = 'in-progress';
export const COMPLETED = 'completed';
export const CANCELLED = 'cancelled';

export const NEW_COLOR = 'red lighten-1';
export const ASSIGNED_COLOR = 'orange lighten-2';
export const IN_PROGRESS_COLOR = 'teal lighten-3';
export const COMPLETED_COLOR = 'green lighten-1';
export const CANCELLED_COLOR = 'blue-grey lighten-4';
